import { createSlice } from "@reduxjs/toolkit";
import { login } from "./Utils/authUtils";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        token: null,
        loading: false,
        error: null,
        success: false,
        redirect: false,
        remember: false,
        form: { email: "", password: "" }, // Ini form data
    },
    reducers: {
        setFormData: (state, action) => {
            state.form = action.payload; // Update form data
        },
        clearAuthState: (state) => {
            state.error = null;
            state.success = false;
            state.redirect = false;
        },
        setRemember: (state, action) => {
            state.remember = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.data;
                state.token = action.payload.bearer;
                state.success = true;
                state.redirect = true;

                localStorage.setItem("TOKEN", action.payload.token);
                localStorage.setItem("USER", JSON.stringify(action.payload.user));
                if (state.remember) {
                    localStorage.setItem("REMEMBER_QEZA", JSON.stringify({ email: state.form.email }));
                } else {
                    localStorage.removeItem("REMEMBER_QEZA");
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const { setFormData, clearAuthState, setRemember } = authSlice.actions;
export default authSlice.reducer;
